module.exports = __webpack_public_path__ + "assets/img/img-future-02.fc2d2488.jpg";